import { render, staticRenderFns } from "./BookToday.vue?vue&type=template&id=709fdf62&scoped=true"
import script from "./BookToday.vue?vue&type=script&lang=js"
export * from "./BookToday.vue?vue&type=script&lang=js"
import style0 from "./BookToday.vue?vue&type=style&index=0&id=709fdf62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fdf62",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BookToday.vue
// module id = 164
// module chunks = 0